export var PaginationVariant;
(function (PaginationVariant) {
    PaginationVariant["compact"] = "compact";
    PaginationVariant["extended"] = "extended";
    PaginationVariant["minimal"] = "minimal";
    PaginationVariant["minimalWithLabels"] = "minimalWithLabels";
    PaginationVariant["normal"] = "normal";
})(PaginationVariant || (PaginationVariant = {}));
export const paginationVariants = [
    'compact',
    'extended',
    'minimal',
    'minimalWithLabels',
    'normal',
];
export const StartEllipsis = 'start-ellipsis';
export const EndEllipsis = 'end-ellipsis';
//# sourceMappingURL=Pagination.types.mjs.mjs.map